import './MapPolygonMarker.less';
import { Polygon } from '../../../models/Geometries';
import { Layer, Source } from 'react-map-gl';
import { useMemo } from 'react';
import { polygon as polygonFeature } from '@turf/helpers';
import unkinkPolygon from '@turf/unkink-polygon';

interface Props {
  polygon: Polygon;
  hovered: boolean;
  isSync?: boolean;
}

function MapPolygonMarker({ polygon, hovered, isSync }: Props) {

  const features = useMemo(() => {
    try {
      //Cuando un poligono es complejo (se intersecta a si mismo) mapbox tiene problemas
      //para renderizarlo. Esta funcion convierte el poligono complejo en X poligonos simples
      return unkinkPolygon(polygonFeature([polygon.puntos.map(p => [p.longitud, p.latitud])]));
    } catch (e) {
      //durante edicion el poligono puede quedar en estado invalido
      return null;
    }
  }, [polygon]);

  /*
    Se incluye la variable isSync para diferenciar si se selecciono
    una geometria sincronizada o no, y asi hacer el dispatch en el redux y poder mostrar el
    modal correspondiente, ya que las lineas y poligonos no tienen un onClick predeterminado
    se debe de manejar un string unico para asi diferenciarlos en el componente padre y asignarles
    un Onclick.
  */

  return (
    <Source id={'PlygonSource-' + polygon.id}
            type='geojson' data={features as any}>
      <Layer id={isSync ? 'sync_polygon-' + polygon.id : 'polygon-' + polygon.id} type={'line'} paint={{
        'line-color': polygon.color,
        'line-width': hovered ? 3 : 2,
      }} beforeId={'order-polygon'}
      />
      <Layer id={isSync ? 'sync_polygon_fill-' + polygon.id : 'polygon_fill-' + polygon.id} type={'fill'} paint={{
        'fill-color': polygon.color,
        'fill-opacity': hovered ? 0.5 : 0.2,
      }} beforeId={'order-polygon'}
      />
    </Source>
  );
}

export default MapPolygonMarker;
